import React, { Component } from 'react';
import CommonGrid from './CommonGrid';
import { Order as dataOrder } from '../../../../components/Grid/dataProvider';

export default class DictionaryGrid extends Component {

  componentWillMount() {
    this.props.breadcrumbs(this.props.breadcrumbsItems);
  }

  render() {
    return <CommonGrid {...this.props} sort='name' order={dataOrder.ASC} />
  }
}
